module.exports = __webpack_public_path__ + "img/close-red.4f32e119.svg";